export enum FormFactor {
    Desktop = "Desktop",
    Mobile = "Mobile"
}